/* eslint-disable @typescript-eslint/naming-convention */

import { injectable } from '@servicetitan/react-ioc';
import { BattlecardApi } from '../api/battlecard.api';
import { getBaseRequestParams } from '../utils/base-request-params';
import { action, makeObservable, observable, runInAction } from 'mobx';

const MAX_RETRY_COUNT = 2;

@injectable()
export class BattlecardStore {
    @observable
    battlecardLoading = false;

    @observable
    battlecardError?: boolean;

    @observable
    battlecardRequestPerformed = false;

    constructor(private readonly battlecardApi: BattlecardApi) {
        makeObservable(this);
    }

    @action
    initBattlecard = async (jobId: number, retryCount = 1) => {
        this.battlecardLoading = true;
        this.battlecardRequestPerformed = true;
        try {
            await this.battlecardApi.getBattlecard({
                ...getBaseRequestParams(),
                job_id: jobId,
                timezone: new Date().getTimezoneOffset() * 60 * -1,
            });
            runInAction(() => {
                this.battlecardError = false;
                this.battlecardLoading = false;
            });
        } catch {
            if (retryCount < MAX_RETRY_COUNT) {
                await this.initBattlecard(jobId, retryCount + 1);
            } else {
                runInAction(() => {
                    this.battlecardError = true;
                    this.battlecardLoading = false;
                });
            }
        }
    };

    @action
    resetBattlecard = () => {
        this.battlecardError = undefined;
        this.battlecardLoading = false;
        this.battlecardRequestPerformed = false;
    };
}
